import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "PurchaseOrderIdInput",
    "OrderIdInput",
    "CustomerNameInput",
    "CustomerCompanyInput",
    "CustomerEmailInput",
    "CustomerPhoneInput",
    "CustomerStreetInput",
    "CustomerCityInput",
    "CustomerStateInput",
    "CustomerZipInput",
    "SupplierNameInput",
    "SupplierStreetInput",
    "SupplierCityInput",
    "SupplierStateInput",
    "SupplierZipInput",
    "SupplierEmailInput",
    "SupplierPhoneInput",
    "SupplierIdInput",
  ];

  connect() {
    this.element[this.identifier] = this;

    this.initSupplierValues();
  }

  initSupplierValues() {
    this.SupplierNameInputTarget.value = "Hybrid85";
    this.SupplierStreetInputTarget.value = "2005 N Somers Ave";
    this.SupplierCityInputTarget.value = "Fremont";
    this.SupplierStateInputTarget.value = "NE";
    this.SupplierZipInputTarget.value = "68025";
    this.SupplierEmailInputTarget.value = "corn@hybrid85.com";
    this.SupplierPhoneInputTarget.value = "4023824270";
  }

  handlePoSelect(po) {
    // Your existing code for handling the selected PO and updating the form fields
    console.log("po: ", po);
    this.CustomerNameInputTarget.value = po.order.shipping_name;
    this.CustomerCompanyInputTarget.value = po.order.company_name;
    this.CustomerEmailInputTarget.value = po.order.email;
    this.CustomerPhoneInputTarget.value = po.order.phone_number;
    this.CustomerStreetInputTarget.value = po.order.shipping_address;
    this.CustomerCityInputTarget.value = po.order.shipping_city;
    this.CustomerStateInputTarget.value = po.order.shipping_state;
    this.CustomerZipInputTarget.value = po.order.shipping_zipcode;
    this.PurchaseOrderIdInputTarget.value = po.id;
  }

  handleSupplierSelect(supplier) {
    // Your existing code for handling the selected supplier and updating the form fields
    console.log("supplier: ", supplier);
    this.SupplierNameInputTarget.value = supplier.name;
    this.SupplierStreetInputTarget.value = supplier.address;
    this.SupplierCityInputTarget.value = supplier.city;
    this.SupplierStateInputTarget.value = supplier.state;
    this.SupplierZipInputTarget.value = supplier.zipcode;
    this.SupplierIdInputTarget.value = supplier.id;

    if (!supplier.name.includes("Nebraska Irrigated")) {
      this.SupplierEmailInputTarget.value = "info@covercropexchange.com";
      this.SupplierPhoneInputTarget.value = "4023824252";
    } else {
      this.SupplierEmailInputTarget.value = "corn@hybrid85.com";
      this.SupplierPhoneInputTarget.value = "4023824270";
    }
  }

  onOrderSearchKeydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }
}
